<template>
  <div id="personal_info">
    <div class="tabbar">
      <div class="isAcitve">
        {{ tabbarLabelC }}
      </div>
    </div>
    <div class="personal_info_content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
  },
  components: {

  },
  data () {
    return {
      selectItem:this.$route.path,
      tabbarLabel:''
    }
  },
  methods: {
  },
  mounted () {

  },
  watch: {

  },
  computed: {
    tabbarLabelC(){
      switch (this.$route.name){
        case 'BasicInfo':
          return '基本信息'
        case 'RNameAuthentication':
          return '实名认证'
        case 'ModifyLoginPwd':
          return '修改登录密码'
        case 'WithdrawalAccount':
          return '设置提现账户'
        case 'PaymentPwd':
          return '支付密码'
        case 'ChangeTelphone':
          return '换绑手机号'
      }
      return ''
    }
  }
}
</script>
<style lang='less' scoped>
  #personal_info{
    display: flex;
    flex-direction: column;
    padding: 20px;
    color: var(--text-main, #111827);

    *,
    *:before,
    *:after {
      box-sizing: border-box;
    }

    .tabbar{
      display: flex;
      min-height: 40px;
      padding: 4px 0 8px;
      align-items: center;
      gap: 8px;
      overflow: visible;
      border: none;
      border-radius: 0;
      background: transparent;

      div{
        position: relative;
        display: flex;
        min-width: 84px;
        height: 34px;
        padding: 0 16px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        border-radius: 4px;
        color: var(--text-secondary, #5A5F6B);
        font-family: PingFang SC-Regular, PingFang SC;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        transition: color .2s ease, background .2s ease, box-shadow .2s ease;
      }

      div:hover{
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
      }

      .isAcitve{
        position: relative;
        color: #FFFFFF;
        font-weight: 500;
        background: transparent;
        box-shadow: none;
      }

      .isAcitve::before{
        content: "";
        position: absolute;
        inset: 0;
        z-index: -1;
        border-radius: 4px;
        background: var(--bg-dark, #1A1D24);
        transform: skewX(-12deg);
      }

      .isAcitve::after{
        content: "";
        position: absolute;
        left: 16px;
        right: 16px;
        bottom: -8px;
        height: 3px;
        border-radius: 2px;
        background: var(--primary, #FF5A1F);
      }

      .isAcitve:hover{
        color: #FFFFFF;
        background: transparent;
        box-shadow: none;
      }

      .isAcitve:hover::before{
        background: var(--bg-dark, #1A1D24);
      }
    }

    .personal_info_content{
      min-height: 560px;
    }
  }
</style>
